var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWrongNetworkLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 176,
    viewBox: "0 0 252 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6581 80C56.6581 98.0924 63.8455 115.444 76.6392 128.237C89.4329 141.03 106.785 148.217 124.878 148.217V160C103.66 160 83.3107 151.571 68.3073 136.569C53.3038 121.566 44.875 101.217 44.875 80H56.6581Z",
    fill: "url(#paint0_linear_10771_49509)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.118 31.7631C160.324 18.9699 142.972 11.7827 124.879 11.7827V0C146.097 0 166.446 8.42858 181.45 23.4315C196.453 38.4344 204.882 58.7827 204.882 80C204.882 101.217 196.453 121.566 181.45 136.569C166.446 151.571 146.097 160 124.879 160V148.217C142.972 148.217 160.324 141.03 173.118 128.237C185.911 115.444 193.099 98.0924 193.099 80C193.099 61.9076 185.911 44.5563 173.118 31.7631Z",
    fill: "url(#paint1_linear_10771_49509)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.878 11.7827C106.785 11.7827 89.4329 18.9699 76.6392 31.7631C63.8455 44.5563 56.6581 61.9076 56.6581 80H44.875C44.875 58.7827 53.3038 38.4344 68.3073 23.4315C83.3107 8.42858 103.66 0 124.878 0V11.7827Z",
    fill: "url(#paint2_linear_10771_49509)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7199 69.3322C61.8316 100.886 82.6386 131.238 114.194 137.127C145.748 143.015 176.102 122.208 181.99 90.6547C187.879 59.1009 167.072 28.7482 135.517 22.8602C103.962 16.9722 73.6081 37.7784 67.7199 69.3322ZM113.8 139.236C81.0796 133.131 59.5043 101.658 65.61 68.9385C71.7157 36.2195 103.19 14.6449 135.91 20.7504C168.631 26.8559 190.206 58.3294 184.1 91.0484C177.995 123.767 146.52 145.342 113.8 139.236Z",
    fill: "url(#paint3_linear_10771_49509)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5656 26.7354L28.7901 19.4143L31.4829 29.4635L21.5656 26.7354ZM35.9067 45.9729L26.2741 55.7344L13.0511 52.0969L9.90949 40.3728L23.1325 44.0103L32.7652 34.2488L35.9067 45.9729ZM5.93442 25.5382L15.8517 28.2663L8.62721 35.5874L5.93442 25.5382ZM20.7783 29.5108L30.6955 32.2389L23.4711 39.56L20.7783 29.5108ZM20.6141 40.3255L10.6968 37.5974L17.9213 30.2763L20.6141 40.3255ZM26.7205 17.4043L18.2599 25.826L6.72177 22.7628L15.1183 14.1019L26.7205 17.4043ZM2.17987 22.9539L10.5788 54.298L27.0435 58.6056L39.1484 46.6431L30.7495 15.299L14.2848 10.9914L2.17987 22.9539Z",
    fill: "url(#paint4_linear_10771_49509)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.978 51.897L113.355 53.5174C113.355 53.5174 110.848 51.6812 109.825 49.7735C108.938 48.1201 108.725 45.484 108.725 45.484C108.725 45.484 111.095 46.119 112.17 45.7864C113.157 45.4812 113.466 45.2531 113.466 45.2531C113.466 45.2531 113.04 49.1372 114.978 51.897ZM149.878 78.4098C150.201 76.4018 148.931 73.631 148.931 73.631C151.563 73.7932 152.553 76.2891 152.553 78.3672C152.553 80.4453 151.213 82.801 149.596 84.3239C147.98 85.8467 147.612 87.5331 147.612 87.5331C146.976 85.7944 147.311 84.8839 147.69 83.8548C148.041 82.9014 148.43 81.8463 148.119 79.9368C147.805 77.9851 146.489 76.4788 145.232 75.4521C144.644 75.8048 143.985 76.2707 143.251 76.789C138.716 79.9929 131.346 85.2005 120.382 78.0799C109.77 71.1875 107.003 72.3283 105.183 73.0789C104.819 73.2292 104.492 73.3638 104.148 73.4152C105.15 73.4835 106.146 73.6259 107.127 73.8413C107.127 73.8413 102.348 75.9634 101.7 79.934C101.389 81.8435 101.778 82.8986 102.129 83.852C102.508 84.8811 102.843 85.7917 102.208 87.5304C102.208 87.5304 101.841 85.8495 100.224 84.3253C98.608 82.801 97.2679 80.4467 97.2679 78.3686C97.2679 76.2905 98.2616 73.7973 100.894 73.6351C100.894 73.6351 99.6237 76.4059 99.9467 78.4139C99.9467 78.4139 101.013 74.6989 102.309 73.7038L101.736 72.2442C104.752 70.5995 107.971 69.3597 111.311 68.5567C111.311 68.5567 108.169 67.1232 102.579 69.1422L101.684 66.0126C107.766 63.0604 114.119 61.8798 120.915 61.7217C120.915 61.7217 113.471 59.7536 104.147 62.5862C104.134 62.2719 104.105 62.0462 104.082 61.8663C104.038 61.5268 104.015 61.3501 104.158 61.0483C104.269 60.8379 104.417 60.649 104.594 60.4903C104.73 60.3762 107.002 58.562 113.712 57.8459C113.712 57.8459 111.041 56.7601 106.368 57.5999C106.559 56.066 107.018 54.5652 108.943 54.1528C110.732 53.7763 111.54 54.1678 112.855 54.8052C113.475 55.1053 114.206 55.4599 115.206 55.8145C116.496 56.2714 118.401 56.2779 120.167 56.284C120.897 56.2864 121.604 56.2889 122.234 56.323C116.409 55.7087 113.642 53.8079 113.642 53.8079C113.642 53.8079 114.791 52.3551 116.168 51.9208C116.595 51.786 117.068 51.7324 117.584 51.6737C118.732 51.5433 120.098 51.388 121.68 50.2619C123.972 48.6291 125.94 48.8064 125.94 48.8064C125.94 48.8064 127.905 48.6291 130.201 50.2619C131.785 51.3878 133.152 51.5432 134.299 51.6736C134.816 51.7323 135.288 51.786 135.714 51.9208C136.848 52.2768 137.827 53.3255 138.137 53.6855C138.854 53.4464 139.589 53.3818 140.709 53.6182C142.424 53.9797 143.099 56.3327 143.363 57.927C141.854 57.6136 138.089 57.1463 130.522 57.8459C130.522 57.8459 139.021 58.3104 143.962 60.4779C144.476 60.7912 145.15 61.2737 145.382 61.7643C145.775 62.5958 145.671 64.8622 145.671 64.8622L148.05 66.0168L147.278 69.193C147.278 69.193 138.001 64.9585 124.867 66.113C124.867 66.113 138.425 65.9219 147.496 71.4196L148.142 71.8814L147.443 73.6475C148.772 74.5615 149.878 78.4098 149.878 78.4098ZM116.022 111.146C114.774 110.754 113.736 109.438 113.736 109.438C113.736 109.438 117.292 106.991 124.865 106.991C132.439 106.991 135.999 109.438 135.999 109.438C135.999 109.438 134.96 110.763 133.713 111.156C133.326 111.278 132.899 111.326 132.432 111.379C131.395 111.497 130.16 111.638 128.726 112.657C126.648 114.134 124.868 113.973 124.868 113.973C124.868 113.973 123.086 114.124 121.009 112.647C119.575 111.627 118.339 111.487 117.301 111.369L117.301 111.369C116.835 111.316 116.409 111.267 116.022 111.146ZM155.81 67.9835C153.075 66.451 148.586 66.1569 148.586 66.1569L147.863 69.3977C152.375 71.26 154.88 76.3302 154.88 76.3302C154.88 76.3302 155.08 75.8121 156.048 74.6713C157.102 73.4344 160.489 72.3651 160.489 72.3651C160.489 72.3651 158.178 69.3056 155.81 67.9835ZM148.805 106.262C148.805 106.262 148.658 106.596 148.578 107.578C148.49 108.644 149.572 110.714 149.572 110.714C149.572 110.714 147.079 111.06 145.361 110.577C143.769 110.127 142.023 108.784 141.395 108.27C141.179 108.386 140.948 108.471 140.708 108.522C138.917 108.899 138.109 108.506 136.795 107.868C136.177 107.568 135.447 107.213 134.45 106.859C131.334 105.751 124.867 105.728 124.867 105.728C124.867 105.728 118.403 105.741 115.286 106.855C114.293 107.209 113.566 107.562 112.949 107.861C111.63 108.501 110.823 108.892 109.028 108.518C107.102 108.112 106.693 106.409 106.502 104.874C111.171 105.715 113.715 104.29 113.715 104.29C107.005 103.57 104.734 101.758 104.597 101.646C104.419 101.487 104.272 101.297 104.161 101.086C103.984 100.711 104 100.437 104.032 99.8571L104.032 99.857C104.04 99.7248 104.048 99.5768 104.055 99.4081C113.378 102.241 120.921 100.414 120.921 100.414C114.125 100.256 107.772 99.0755 101.69 96.1219L102.618 92.6474C108.445 94.1084 111.317 93.5779 111.317 93.5779C107.977 92.7752 104.758 91.5353 101.743 89.8903L102.475 88.0404C111.894 91.8887 137.853 91.8887 147.272 88.0404L148.149 90.2573L147.503 90.7191C138.435 96.2181 124.874 96.0257 124.874 96.0257C138.002 97.1816 147.278 92.9457 147.278 92.9457L148.052 96.1247L145.673 97.2805C145.673 97.2805 145.974 100.258 145.58 101.089C145.348 101.58 144.675 102.062 144.161 102.375C139.219 104.55 130.522 104.3 130.522 104.3C138.095 105.001 141.792 105.079 143.304 104.766C145.066 105.5 146.915 106.003 148.805 106.262ZM99.9009 84.8257C95.394 86.699 90.0378 84.8834 90.0378 84.8834C90.0378 84.8834 90.2618 85.3864 90.3869 86.8832C90.5243 88.505 88.875 91.6551 88.875 91.6551C88.875 91.6551 92.6671 92.1815 95.2813 91.4448C98.3051 90.5941 101.682 87.6281 101.682 87.6281L99.9009 84.8257ZM110.8 80.3459C110.8 80.3459 109.596 83.2321 111.953 84.3921C114.31 85.5521 120.236 84.9639 120.236 84.9639C120.236 84.9639 115.099 81.1788 110.8 80.3459ZM138.629 86.224C140.614 85.7155 140.152 83.3144 140.152 83.3144L140.154 83.3144C136.735 83.2691 132.211 85.3472 132.211 85.3472C132.211 85.3472 136.645 86.7326 138.629 86.224Z",
    fill: "#20D5A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M211.379 130.652C209.109 129.737 207.468 128.451 206.453 126.796C205.46 125.131 205.374 123.281 206.183 121.275C206.356 120.846 206.605 120.359 206.944 119.783C207.743 118.503 208.76 116.991 210.001 115.23C213.42 110.484 217.833 109.201 223.224 111.375C224.687 111.965 225.913 112.744 226.866 113.716C227.832 114.658 228.45 115.761 228.725 117.012C229.006 118.247 228.878 119.53 228.34 120.863C228.18 121.261 227.93 121.748 227.592 122.323C226.617 123.907 225.609 125.441 224.549 126.883C222.823 129.231 220.884 130.746 218.715 131.385C216.566 132.014 214.12 131.757 211.379 130.652ZM213.457 126.683C214.523 127.113 215.552 127.154 216.551 126.827C217.566 126.506 218.503 125.762 219.354 124.574C220.524 122.945 221.489 121.518 222.261 120.263C222.498 119.895 222.71 119.5 222.883 119.072C223.587 117.326 223.041 116.091 221.228 115.36C220.162 114.93 219.119 114.883 218.104 115.204C217.105 115.531 216.182 116.28 215.332 117.468C214.463 118.614 213.498 120.04 212.394 121.767C212.163 122.12 211.957 122.499 211.784 122.928C211.053 124.698 211.63 125.946 213.457 126.683Z",
    fill: "url(#paint5_linear_10771_49509)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M223.757 135.642C223.543 135.556 223.415 135.433 223.348 135.246C223.318 135.057 223.356 134.876 223.466 134.689L234.945 117.624C235.062 117.422 235.237 117.297 235.475 117.233C235.699 117.163 235.907 117.176 236.105 117.256L243.723 120.328C245.845 121.184 247.361 122.31 248.292 123.699C249.232 125.11 249.376 126.644 248.704 128.311C248.513 128.785 248.248 129.265 247.931 129.742C246.57 131.754 244.954 132.987 243.063 133.452C241.203 133.929 239.024 133.654 236.52 132.645L232.658 131.087L228.81 136.844C228.677 137.04 228.518 137.171 228.279 137.235C228.056 137.305 227.848 137.292 227.65 137.212L223.757 135.642ZM238.316 128.763C239.125 129.09 239.898 129.153 240.673 128.949C241.462 128.752 242.112 128.285 242.643 127.539C242.834 127.242 242.982 126.964 243.08 126.719C243.302 126.169 243.307 125.673 243.104 125.253C242.907 124.818 242.403 124.437 241.625 124.123L238.19 122.738L235.034 127.44L238.316 128.763Z",
    fill: "url(#paint6_linear_10771_49509)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2594 150.318L44.0118 154.827C44.0302 154.954 44.0961 155.068 44.1963 155.147L50.2565 160.162L52.1146 157.02L43.7039 150.062C43.5092 149.9 43.2168 150.068 43.2594 150.318Z",
    fill: "url(#paint7_linear_10771_49509)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4304 142.479C42.2358 142.317 41.9435 142.486 41.9861 142.735L42.7384 147.244C42.7568 147.371 42.8227 147.485 42.923 147.565L52.8494 155.774L54.7074 152.632L42.4304 142.479Z",
    fill: "url(#paint8_linear_10771_49509)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8556 137.174C32.9258 137.134 33 137.114 33.0841 137.111L47.003 136.988C47.1654 136.986 47.3139 137.068 47.3929 137.205L54.2262 149.063C54.3053 149.2 54.3018 149.37 54.2185 149.509L47.1362 161.496C47.0975 161.564 47.0372 161.621 46.967 161.662C46.8969 161.702 46.8226 161.722 46.7386 161.725L32.8255 161.845C32.6631 161.847 32.5146 161.765 32.4356 161.628L25.5989 149.764C25.5199 149.627 25.5234 149.457 25.6067 149.318L32.6923 137.337C32.731 137.269 32.7913 137.211 32.8556 137.174ZM31.8573 135.442C31.4831 135.657 31.1648 135.97 30.9402 136.351L23.8546 148.332C23.4054 149.094 23.3922 150.03 23.8271 150.785L30.6604 162.643C31.0953 163.398 31.9158 163.862 32.7999 163.855L46.7187 163.732C47.1608 163.728 47.5911 163.61 47.9653 163.394C48.3395 163.178 48.6578 162.866 48.8824 162.485L55.968 150.504C56.4231 149.739 56.4304 148.805 55.9922 148.045L49.1589 136.187C48.724 135.433 47.9036 134.969 47.0194 134.975L33.1097 135.101C32.6618 135.108 32.2315 135.226 31.8573 135.442Z",
    fill: "url(#paint9_linear_10771_49509)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1209 143.148L32.4603 144.681C32.2615 144.796 32.1493 145.02 32.1905 145.24L35.2999 163.829L38.9503 163.797L35.5269 143.325C35.4938 143.146 35.2905 143.05 35.1209 143.148Z",
    fill: "url(#paint10_linear_10771_49509)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7814 140.465L37.1208 141.998C36.9219 142.112 36.8098 142.337 36.8509 142.557L40.3996 163.787L44.05 163.755L40.1848 140.651C40.1543 140.463 39.9452 140.37 39.7814 140.465Z",
    fill: "url(#paint11_linear_10771_49509)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10771_49509)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10771_49509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.431 28.4905C224.285 30.5477 231.507 26.6685 233.56 19.826C235.614 12.9836 231.722 5.76905 224.868 3.71188C218.365 1.76015 211.531 5.1518 209.094 11.3479L225.499 16.2713L224.873 18.3541L208.469 13.4307C207.092 19.9448 210.928 26.5388 217.431 28.4905Z",
    fill: "url(#paint12_linear_10771_49509)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10771_49509",
    x1: 44.8643,
    y1: 119.995,
    x2: 124.878,
    y2: 119.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EE4AD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CE92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10771_49509",
    x1: 124.868,
    y1: 79.9893,
    x2: 204.882,
    y2: 79.9893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EE4AD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CE92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10771_49509",
    x1: 44.8643,
    y1: 39.9946,
    x2: 124.878,
    y2: 39.9946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EE4AD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CE92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10771_49509",
    x1: 113.789,
    y1: 139.251,
    x2: 135.901,
    y2: 20.7486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EE4AD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CE92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10771_49509",
    x1: 6.37465,
    y1: 38.6238,
    x2: 34.9479,
    y2: 30.9673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EE4AD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CE92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10771_49509",
    x1: 207.827,
    y1: 117.191,
    x2: 226.745,
    y2: 124.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EE4AD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CE92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10771_49509",
    x1: 227.215,
    y1: 125.352,
    x2: 246.724,
    y2: 133.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EE4AD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CE92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10771_49509",
    x1: 44.7988,
    y1: 156.265,
    x2: 49.9644,
    y2: 153.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EE4AD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CE92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10771_49509",
    x1: 44.6979,
    y1: 150.718,
    x2: 51.3841,
    y2: 146.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EE4AD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CE92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10771_49509",
    x1: 27.2409,
    y1: 156.717,
    x2: 52.5761,
    y2: 142.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EE4AD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CE92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10771_49509",
    x1: 31.2505,
    y1: 156.805,
    x2: 40.3052,
    y2: 151.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EE4AD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CE92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10771_49509",
    x1: 35.724,
    y1: 155.676,
    x2: 45.5879,
    y2: 149.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EE4AD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CE92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10771_49509",
    x1: 208.779,
    y1: 12.3866,
    x2: 233.561,
    y2: 19.8244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EE4AD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CE92"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10771_49509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0977,
    height: 26.0977,
    fill: "white",
    transform: "translate(212.5) rotate(16.7059)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10771_49509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0977,
    height: 26.0977,
    fill: "white",
    transform: "translate(212.5) rotate(16.7059)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongNetworkLight);
export default __webpack_public_path__ + "static/media/wrong-networkLight.09904bbb0eac1cf344a5e8df59f44e5f.svg";
export { ForwardRef as ReactComponent };